import LogoutRedirect from '../core/no-auth/logout-redirect';

import { NO_AUTH_PATH } from './paths';
import { NoAuthRoute } from './interfaces';

const logoutRoute: NoAuthRoute = {
  exact: true,
  path: NO_AUTH_PATH.LOGOUT_REDIRECT,
  render: () => <LogoutRedirect />
};

export const getNoAuthRoutes = () => [logoutRoute];
